/* istanbul ignore file */
import {
  productItemCustomCssVars,
  productItemShouldRenderVars,
} from './common/components/ProductItem/ProductItem.cssVars';
import {carouselCustomCssVars} from './common/components/Carousel/Carousel.cssVars';
import {heroCustomCssVars, heroShouldRenderVars} from './category/components/Hero/Hero.cssVars';
import {BooleanStyleParamsKeys} from './styleParams/types';
import {arrowsNavigationWrapperCssVars} from './sliderGallery/components/SliderGallery/ArrowsNavigationWrapper/ArrowsNavigationWrapper.cssVars';
import {sliderGalleryCssVars} from './sliderGallery/components/SliderGallery/SliderGallery.cssVars';
import {
  categoryTreeCustomCssVars,
  categoryTreeShouldRenderVars,
} from './category/components/CategoryTree/CategoryTree.cssVars';
import {
  extendedGridGalleryCustomCssVars,
  extendedGridGalleryShouldRenderVars,
} from './common/ExtendedGridGallery/ExtendedGridGallery.cssVars';
import {getDisplayCssVars} from '@wix/wixstores-client-storefront-common';
import type {CustomCssVarsFnParams, ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {filtersCustomCssVars, filtersShouldRenderVars} from './gallery/components/Filters/Filters.cssVars';
import {
  mobileFiltersAndSortCustomCssVars,
  mobileFiltersAndSortShouldRenderVars,
} from './common/components/MobileFiltersAndSort/MobileFiltersAndSort.cssVars';
import {galleryAppCustomCssVars} from './gallery/components/GalleryApp/GalleryApp.cssVars';
import {promotionItemCustomCssVars} from './gallery/components/ProductList/PromotionItem/PromotionItem.cssVars';

export type {CustomCssVarsFnParams, ShouldRenderVarsFnParams};
export type ShouldRenderVarsKeys = keyof ReturnType<typeof getBaseShouldRenderValues> | BooleanStyleParamsKeys;

const getBaseCustomCssVars = ({styleParams: styles, isMobile, isRTL}: CustomCssVarsFnParams) => {
  return {
    filtersHeaderPaddingBottom: styles.booleans.gallery_showFiltersTitle ? '20px' : '0',
    ...promotionItemCustomCssVars({styleParams: styles, isMobile, isRTL}),
    ...extendedGridGalleryCustomCssVars({styleParams: styles, isMobile, isRTL}),
    ...heroCustomCssVars({styleParams: styles, isMobile, isRTL}),
    ...carouselCustomCssVars({styleParams: styles, isMobile, isRTL}),
    ...productItemCustomCssVars({styleParams: styles, isMobile, isRTL}),
    ...arrowsNavigationWrapperCssVars({styleParams: styles, isMobile, isRTL}),
    ...sliderGalleryCssVars({styleParams: styles, isMobile, isRTL}),
    ...categoryTreeCustomCssVars({styleParams: styles, isMobile, isRTL}),
    ...filtersCustomCssVars({styleParams: styles, isMobile, isRTL}),
    ...mobileFiltersAndSortCustomCssVars({styleParams: styles, isMobile, isRTL}),
    ...galleryAppCustomCssVars({styleParams: styles, isMobile, isRTL}),
  };
};

export const getBaseShouldRenderValues = (shouldRenderVarsFnParams: ShouldRenderVarsFnParams) => {
  return {
    showTitleWasTurnedOn: shouldRenderVarsFnParams.booleans.gallery_showTitle === true,
    showTitleWasNeverChanged: shouldRenderVarsFnParams.booleans.gallery_showTitle === undefined,
    ...heroShouldRenderVars(shouldRenderVarsFnParams),
    ...productItemShouldRenderVars(shouldRenderVarsFnParams),
    ...categoryTreeShouldRenderVars(shouldRenderVarsFnParams),
    ...extendedGridGalleryShouldRenderVars(shouldRenderVarsFnParams),
    ...filtersShouldRenderVars(shouldRenderVarsFnParams),
    ...mobileFiltersAndSortShouldRenderVars(shouldRenderVarsFnParams),
  };
};

export const baseCustomCssVars = (params: CustomCssVarsFnParams) => {
  const baseCssVars = getBaseCustomCssVars(params);
  const shouldRenderVars = getBaseShouldRenderValues({
    booleans: params.styleParams.booleans,
    numbers: params.styleParams.numbers,
    strings: params.styleParams.strings,
    isMobile: params.isMobile,
    isRTL: params.isRTL,
  });

  const displayCssVars = getDisplayCssVars({...params.styleParams.booleans, ...shouldRenderVars});
  return {...baseCssVars, ...displayCssVars};
};
